import { render, staticRenderFns } from "./ReportProducts.vue?vue&type=template&id=4cb4d6e8&"
import script from "./ReportProducts.vue?vue&type=script&lang=js&"
export * from "./ReportProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports